define ('bizzabo/models/ValidationObject',['bizzabo/consts', 'backbone', 'backbone-validation'], function(Consts, Backbone, BackboneValidation) {

    var ValidationObject = function(model) {
        this.model = model;

        Backbone.Validation.bind(this, {
            forceUpdate : true,
            valid : function(view, attr) {
                model.trigger(Consts.Strings.VALIDATION_NAME, {
                    attr : attr,
                    isValid : true
                });
            },
            invalid : function(view, attr, error) {
                model.trigger(Consts.Strings.VALIDATION_NAME, {
                    attr : attr,
                    isValid : false,
                    error : error
                });
            }
        });
    };

    return ValidationObject;

});

